export default __webpack_public_path__ + "static/media/xls-file.9cbeb629.svg";